// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YuSj","colBig":"styles_colBig__3kgn-","colSmall":"styles_colSmall__1hgdL","shopifyNameWrapper":"styles_shopifyNameWrapper__2Csxx"};